import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { AdministrationMessageItemTranslation, AdministrationMessageItem, MessagesValidation } from '../types-store';

export const validateMessage = (
  message: AdministrationMessageItem,
  languageOptions: ComplexValue<number>[],
  validationErrorMessage: string
): MessagesValidation => {

  const allTranslations = (languageOptions || [])
    .map(option => (message && message.translations || [])
      .find(language => language.language === option.value)
      || { language: option.value } as AdministrationMessageItemTranslation
    );

  const subjectValidation = allTranslations
    .map(language =>
      language.subject === undefined || language.subject.trim() === ''
        ? {
          level: ValidationLevel.error,
          message: validationErrorMessage,
          parameters: {
            subject: language.language
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const messageValidation = allTranslations
    .map(language =>
      language.message === undefined || language.message.trim() === ''
        ? {
          level: ValidationLevel.error,
          message: validationErrorMessage,
          parameters: {
            message: language.language
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  return subjectValidation.length > 0 || messageValidation.length > 0
    ? {
      translations: {
        level: ValidationLevel.error,
        messages: [
          ...subjectValidation,
          ...messageValidation
        ]
      }
    }
    : undefined;
};
